import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-startup-paused',
  templateUrl: './startup-paused.component.html',
  styleUrls: ['./startup-paused.component.scss']
})
export class StartupPausedComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  closeDialog() {
    this.activeModal.close();
  }
}
